import React, { Fragment } from 'react';
import { FormGroup, FormControl, Radio } from 'react-bootstrap';
import CurrencySelector from 'components/Shared/Selectors/CurrencySelector';
import styles from './postbudget.module.scss';

const PostBudget = ({
  budget,
  currency,
  fixedBudget,
  onChangeBudget,
  onChangeCurrency,
  onSetFixedBudget,
  specificFreelancerSelected,
  isPrivate,
}) => {
  let currencySymbol = '$';
  if (currency === 'gbp') {
    currencySymbol = '£';
  } else if (currency === 'eur') {
    currencySymbol = '€';
  }

  const firstRadioButtonText = `Receive offer${
    specificFreelancerSelected && isPrivate ? '' : 's'
  }`;

  const currencySelector = (
    <CurrencySelector
      value={{ label: currency.toUpperCase(), value: currency }}
      style={{ fontSize: '15px', width: '110px' }}
      onChange={(input) => onChangeCurrency(input.value)}
      options={[
        { label: 'USD ($)', value: 'usd' },
        { label: 'GBP (£)', value: 'gbp' },
      ]}
    />
  );

  return (
    <form className={styles.form} id="post-brief-budget">
      <p className="fs-15 lato-bold">Would you like to set a budget?</p>
      <FormGroup>
        <div style={{ border: '1px solid #ddd', borderRadius: '4px' }}>
          <div className="fs-15" style={{ borderTop: 0, padding: '10px' }}>
            <Radio
              className={styles.radio}
              id="post-brief-receive-offers"
              onChange={() => onSetFixedBudget(false)}
              checked={!fixedBudget}
            >
              {firstRadioButtonText}
            </Radio>
          </div>
          <div
            className="fs-15"
            style={{ borderTop: '1px solid #ddd', padding: '10px' }}
          >
            <Radio
              className={styles.radio}
              id="post-brief-fixed-price"
              onChange={() => onSetFixedBudget(true)}
              checked={fixedBudget}
            >
              Set a budget
            </Radio>
          </div>
        </div>
        <hr />
        {fixedBudget ? (
          <Fragment>
            <p className="fs-15 lato-bold">Project budget:</p>
            <div style={{ display: 'inline-block', width: '40%' }}>
              {currencySelector}
            </div>
            <div
              className="ml"
              style={{ display: 'inline-block', width: '50%' }}
            >
              <FormControl
                id="post-brief-fixed-price-amount"
                type="number"
                value={budget > 0 ? budget / 100 : ''}
                placeholder="100.00"
                style={{
                  width: '110px',
                  height: '40px',
                  display: 'inline',
                  paddingLeft: '20px',
                  fontSize: '15px',
                }}
                onChange={(event) => onChangeBudget(event.target.value * 100)}
              />
              <div
                className="aside-text fs-15 pl"
                style={{ display: 'inline' }}
              >
                {currencySymbol}
              </div>
            </div>
          </Fragment>
        ) : (
          <Fragment>
            <div>
              <p className="fs-15">
                All payments on this project will be in this currency
              </p>
            </div>
            <div>{currencySelector}</div>
          </Fragment>
        )}
      </FormGroup>
    </form>
  );
};

export default PostBudget;
